import { useLayoutEffect, useRef, useState } from "react";

const THRESHOLD = 200;

export const useNavigationCollapse = () => {
  const navRef = useRef<HTMLDivElement>(null);
  const lastItemRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLDivElement>(null);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isCalculated, setIsCalculated] = useState(false);

  useLayoutEffect(() => {
    const checkCollision = () => {
      const lastItem = lastItemRef.current;
      const button = buttonRef.current;

      if (!lastItem || !button) return;

      const lastItemRight = lastItem.getBoundingClientRect().right;
      const buttonLeft = button.getBoundingClientRect().left;
      const gap = buttonLeft - lastItemRight;

      const threshold = THRESHOLD;

      setIsCollapsed(gap < threshold);
      setIsCalculated(true);
    };

    const resizeObserver = new ResizeObserver(checkCollision);

    if (navRef.current) resizeObserver.observe(navRef.current);
    if (buttonRef.current) resizeObserver.observe(buttonRef.current);

    window.addEventListener("resize", checkCollision);
    requestAnimationFrame(checkCollision);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", checkCollision);
    };
  }, []);

  return { isCollapsed, isCalculated, lastItemRef, buttonRef, navRef };
};
